import { Localisation } from '@1x2network/legacy_localisation'

/**
 *  Handle loading and applying translations
 *  @author Jordan Harrison - <jordan.harrison@1x2network.com>
 *  @version 1.0.0
 */

/** list of game translations to apply */
export const gameTranslations = {
    'splash_text-0': 'The Collector symbol in the Hold and Win collects the values of all cash symbols on the board!',
    'splash_text-1': 'Land 6 or more Cash symbols to activate the Hold and Win!',
    'paytable_symbol-09-cash': 'Special Bonus Symbol - Displays a cash value that can be won in Hold And Win.',
    'paytable_symbol-10-collector':
        'Special Collector Symbol - Collects Bonus Symbol values and displays a cash value that can be won in Hold And Win.',
    'paytable_symbol-11-mini': 'Special Mini Hold and Win Prize Symbol.',
    'paytable_symbol-12-minor': 'Special Minor Hold and Win Prize Symbol.',
    'paytable_symbol-13-major': 'Special Major Hold and Win Prize Symbol.',
}

/** type utility for keys of the localisation */
export type GameTranslationKeys = keyof typeof gameTranslations

/** singleton for the game localisation */
export const GAME_LOCALISATION = new Localisation({
    translations: gameTranslations,
})
